<template lang="pug">
v-container(
  fluid
  id="website-theme-preview"
  px-0
  py-0
  fill-height
  class=" tw-items-start tw-content-start tw-overflow-x-hidden tw-bg-white "
)
  kubiqa-website-themes-theme-c-components-shared-top-navigation(
    :changeOnScroll="false"
    titleColor="tw-text-black"
    appBarBg="tw-bg-white tw-border tw-border-gray-lighten-2 tw-rounded-lg pt-12 pb-16 mt-1"
  )
  v-row(justify="center" align="center" class=" pb-0 mb-0 tw-mt-32  ")
    v-col(cols="12" class="tw-h-full pt-0 ")
      div(
        class="header-container tw-h-full px-12 tw-w-full tw-rounded-lg tw-mx-auto tw-bg-gray-darken-2"
        :style="page.background_image ? 'background-image: url(' + path(page.background_image) + ');' : ''"
      )
        div(class="tw-grid tw-h-full tw-w-full")
          div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-h-full tw-col-start-1 tw-w-full py-5 mx-0")
            kubiqa-website-shared-widget-editor(
              page="about"
              placement="header"
              @content="(content) => (content != null ? (defaultHeader = false) : (defaultHeader = true))"
            )
            div(v-if="defaultHeader" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
              div(class="tw-h-full  tw-items-center tw-flex")
                v-row(no-gutters justify="center" class="tw-mt-4")
                  v-col(cols="9")
                    span(class="tw-font-bold tw-text-white tw-text-2xl") About us
  v-row(align="start" justify="center" class="  tw-z-0 tw-mt-3 tw-pt-12 flex-grow-1 d-fex flex-row")
    v-col(cols="12")
      div(class="tw-grid fill-height")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
          kubiqa-website-shared-widget-editor(
            page="about"
            placement="description"
            @content="(content) => (content != null ? (defaultDescription = false) : (defaultDescription = true))"
            class=" fill-height"
          )
        div(v-if="defaultDescription" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12 tw-align-middle")

  v-row(class="tw-pt-24 ")
    v-col
  kubiqa-website-themes-theme-c-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      defaultHeader: true,
      defaultDescription: true,
    };
  },
  computed: {
    page() {
      return this.$store.state.website.website.pages.about;
    },
  },
};
</script>
<style lang="css">
.header-container {
  height: 350px !important;
}
</style>
